import {
  authorizeGetRequest,
  authorizePatchRequest,
  authorizePostRequest,
  authorizePutRequest,
} from "api";
import { IApiResponse, IPaginatedResponse } from "models";
import {
  IAccount,
  IAccountFinanceResponse,
  IAccountInput,
  IEditAccountInput,
} from "models/account";
import { IChangePasswordInput } from "models/auth";

export const accountsApi = (page: number, perPage: number, search: string) => {
  if (search) search = search.replace("+", "%2B");

  return authorizeGetRequest<IPaginatedResponse<IAccount>>(
    `accounts?page=${page}&per_page=${perPage}&query=${search}`
  );
};

export const banAccountApi = (id: string) => {
  return authorizePutRequest<IApiResponse<IAccount>>(`accounts/${id}/ban`, {});
};

export const activateAccountApi = (id: string) => {
  return authorizePutRequest<IApiResponse<IAccount>>(
    `accounts/${id}/activate`,
    {}
  );
};

export const createAccountApi = (data: IAccountInput) => {
  return authorizePostRequest<IApiResponse<IAccount>>("accounts", data);
};

export const changePasswordApi = (data: IChangePasswordInput) => {
  return authorizePutRequest<IApiResponse<IAccount>>(
    "accounts/change-password",
    data
  );
};

export const fetchAccountByIdApi = (id: string) => {
  return authorizeGetRequest<IApiResponse<IAccount>>(`accounts/${id}`);
};

export const updateAccountApi = (id: string, data: IEditAccountInput) => {
  return authorizePatchRequest<IApiResponse<IAccount>>(`accounts/${id}`, data);
};

export const accountFinanceByIdApi = (
  id: string,
  page: number,
  perPage: number,
  startDate: string,
  endDate: string
) => {
  return authorizeGetRequest<IAccountFinanceResponse>(
    `accounts/${id}/finance?page=${page}&per_page=${perPage}&start-date=${startDate}&end-date=${endDate}`
  ); // Note: `per-page` is used in the API, not `perPage`
};

export const accountFinanceApi = (
  page: number,
  perPage: number,
  startDate: string,
  endDate: string
) => {
  return authorizeGetRequest<IAccountFinanceResponse>(
    `accounts/finance?page=${page}&per_page=${perPage}&start-date=${startDate}&end-date=${endDate}`
  ); // Note: `per-page` is used in the API, not `perPage`
};

export const resetAccountPasswordApi = (id: string, password: string) => {
  return authorizePutRequest<IApiResponse<IAccount>>(
    `accounts/${id}/reset-password`,
    {
      password,
    }
  );
};
